import React from 'react';

const Logos: React.FC = () => {
  return (
    <section className="section bg-white">
      <div className="container">
        <h2 className="text-center" style={{ fontSize: '2rem', marginBottom: '48px', color: '#2d3748' }}>
          Featured In & Partners
        </h2>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '80px',
          flexWrap: 'wrap'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '200px'
          }}>
            <img
              src="/TED_three_letter_logo.svg"
              alt="TED"
              style={{
                height: '60px',
                width: 'auto',
                objectFit: 'contain'
              }}
            />
          </div>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '200px'
          }}>
            <img
              src="/Logo-CGS-Final-TM_color-tag-1-300x300.jpg"
              alt="Common Ground Society"
              style={{
                height: '100px',
                width: 'auto',
                objectFit: 'contain'
              }}
            />
          </div>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '200px'
          }}>
            <img
              src="/grand-central-petaluma.png"
              alt="Grand Central Petaluma"
              style={{
                height: '110px',
                width: 'auto',
                objectFit: 'contain'
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Logos;
